import { isFieldConfig } from '~/utils/isFieldConfig';

/**
 * Returns a set of refs for managing multiple fields in a form,
 * generated from a list of FieldConfigs, with any `initialData`
 * provided applied as the initial values.
 */
export default <T = GenericFormData>(
  options: {
    fields: FormConfig[]
    initialData?: Partial<T>
  },
) => {
  const { fields, initialData } = options;
  const { rulesFromFieldConfig } = useFormRules();

  const fieldsFlat = fields.map(field => isFieldConfig(field) ? field : field.fields as FieldConfig[]).flat();

  // Set up initial form data
  const data = ref<T>(useAssignFormData<T>({ fields: fieldsFlat, initialData }));
  // Assign the validation rulset for each field
  const rules = ref<FormRules>(
    fieldsFlat
      .map(field => [field.id, rulesFromFieldConfig(field)] as [string, FormRule[]])
      .reduce(...entriesToObject<FormRules>()),
  );

  // Set up an empty errors map
  const errors = ref<FormErrors>({});

  return { data, rules, errors };
};
